import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';

import { EntityProperties } from '@connect-services/client/models/panel.model';
import { DocumentIdentifiers, DocumentService } from '@connect-services/client/services/document.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { Document } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { FileService } from '@shared/client/services/file.service';

export const maximumTotalSizeInFileSizeUnit = '1 GB';
export const maximumTotalSizeInBytes = FileService.fileSizeToBytes(1, 'GB');
export const maximumFileAmount = 100;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-entity-link-document',
    templateUrl: './entity-link-document.component.html',
})
export class EntityLinkDocumentComponent {
    public readonly data = input.required<DocumentIdentifiers>();
    public readonly dataEntity = input<EntityProperties>();
    public readonly document = input.required<Document>();
    public readonly documentService = inject(DocumentService);
    public readonly isMenuOpen = signal(false);
    public readonly showAddButton = input<boolean>(false);

    protected readonly ButtonType = ButtonType;

    public get documentName(): string {
        return this.document().storagePath.split('/').pop()?.split('.')[0] as string;
    }

    public toggleDropdownMenu(isOpen: boolean): void {
        this.isMenuOpen.set(isOpen);
    }
}
